import { useEffect, useState, useCallback } from "react";
import { createContext } from "react";
import { setExpiredHandler } from "../util/customAxios";

export const UserContext = createContext(null);

const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const login = (userData) => {
    setUser(userData);
  };
  const logout = () => {
    setUser(null);
    localStorage.removeItem("futureOfTV_User");
  };

  const forceExpired = useCallback(() => {
    setUser((prev) => prev ? { ...prev, membership_expired: true } : prev);
  }, []);

  useEffect(() => {
    setExpiredHandler(forceExpired);
  }, [forceExpired]);

  useEffect(() => {
    if (user) {
      localStorage.setItem("futureOfTV_User", JSON.stringify(user));
    }
  }, [user]);

  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
        login,
        logout,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserProvider;
